import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./BreakdownTracker.css";
import "./AddBreakdown.css";

const AddBreakdown = () => {
  const [formData, setFormData] = useState({
    journey_plane_no: "",
    journey_plane_date: "",
    scheduled_vehicle: "",
    driver_name: "",
    driver_phone: "",
    carrier: "",
    issue: "",
    remarks: "",
    truck_status: "",
    breakdown_time: "",
    jp_status: "IN_TRANSIT",
    ivms_point: "",
  });
  const [trucks, setTrucks] = useState([]);
  const [message, setMessage] = useState(""); 
  const navigate = useNavigate();

  const getCurrentLocalDateTime = () => {
    const localDate = new Date();
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");
    const hours = String(localDate.getHours()).padStart(2, "0");
    const minutes = String(localDate.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  useEffect(() => {
    fetchInTransitTrucks();
    const currentDateTime = getCurrentLocalDateTime();
    setFormData((prevState) => ({
      ...prevState,
      breakdown_time: currentDateTime,
    }));
  }, []);

  const fetchInTransitTrucks = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/inTransitTrucks`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setTrucks(response.data);
    } catch (error) {
      console.error("Error fetching in-transit trucks:", error);
    }
  };

  const handleTruckChange = (e) => {
    const { name, value } = e.target;
    const selectedTruck = trucks.find(
      (truck) =>
        (name === "journey_plane_no" && truck.journey_plane_no === value) ||
        (name === "scheduled_vehicle" && truck.scheduled_vehicle === value)
    );

    if (selectedTruck) {
      setFormData({
        ...formData,
        journey_plane_no: selectedTruck.journey_plane_no,
        scheduled_vehicle: selectedTruck.scheduled_vehicle,
        driver_name: selectedTruck.driver_name,
        driver_phone: selectedTruck.driver_phone,
        carrier: selectedTruck.carrier,
        ivms_point: selectedTruck.ivms_point,
      });
    } else {
      setFormData({
        ...formData,
        journey_plane_no: "",
        scheduled_vehicle: "",
        driver_name: "",
        driver_phone: "",
        carrier: "",
        ivms_point: "",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const convertToUTC = (localDateTime) => {
    const date = new Date(localDateTime);
    if (isNaN(date.getTime())) {
      console.error("Invalid date value:", localDateTime);
      return null;
    }
    return date.toISOString();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.truck_status) {
      setMessage("Please select a Truck Status."); // Show error message if Truck_Status is not selected
      setTimeout(() => setMessage(""), 5000);
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const dataToSubmit = {
        ...formData,
        breakdown_time: convertToUTC(formData.breakdown_time),
      };

      delete dataToSubmit.journey_plane_date;

      Object.keys(dataToSubmit).forEach((key) => {
        if ((dataToSubmit[key] === undefined || dataToSubmit[key] === "") && key !== "truck_status") {
          dataToSubmit[key] = null;
        }
      });

      if (!dataToSubmit.breakdown_time) {
        console.error("Invalid date fields in form data:", dataToSubmit);
        return;
      }

      await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/breakdownRecords`,
        dataToSubmit,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage("Breakdown record added successfully!");
      setTimeout(() => setMessage(""), 10000);
      navigate("/breakdown-tracker");
    } catch (error) {
      console.error("Error adding breakdown record:", error);
      setMessage("Failed to add breakdown record.");
      setTimeout(() => setMessage(""), 10000);
    }
  };

  return (
    <div className="container-add-breakdown">
      <button
        className="close-button"
        onClick={() => navigate("/breakdown-tracker")}
      >
        ×
      </button>
      {message && <div className="message">{message}</div>}{" "}
      {/* Display message */}
      <form onSubmit={handleSubmit} className="form-grid-breakdown">
        <div className="block-display-breakdown">
          <label className="form-label-breakdown">
            Truck Number <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="scheduled_vehicle"
            value={formData.scheduled_vehicle}
            onChange={handleTruckChange}
            list="vehicle-list"
            required
          />
          <datalist id="vehicle-list">
            {trucks.map((truck) => (
              <option
                key={truck.scheduled_vehicle}
                value={truck.scheduled_vehicle}
              />
            ))}
          </datalist>
        </div>

        <div>
          <label className="form-label-breakdown">
            Breakdown Date<span className="required">*</span>
          </label>
          <input
            type="datetime-local"
            className="form-input-breakdown"
            name="breakdown_time"
            value={formData.breakdown_time}
            onChange={handleChange}
            required 
          />
        </div>
        <div>
          <label className="form-label-breakdown">
            Journey Number <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="journey_plane_no"
            value={formData.journey_plane_no}
            onChange={handleTruckChange}
            list="journey-list"
            required
          />
          <datalist id="journey-list">
            {trucks.map((truck) => (
              <option
                key={truck.journey_plane_no}
                value={truck.journey_plane_no}
              />
            ))}
          </datalist>
        </div>
        <div>
          <label className="form-label-breakdown">
            Driver Name <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="driver_name"
            value={formData.driver_name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="form-label-breakdown">
            Driver Phone Number <span className="required">*</span>
          </label>
          <input
            type="tel"
            className="form-input-breakdown"
            name="driver_phone"
            value={formData.driver_phone}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="form-label-breakdown">
            Last Check Point <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="ivms_point"
            value={formData.ivms_point || ""}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="form-label-breakdown">
            Carrier <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="carrier"
            value={formData.carrier}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="form-label-breakdown">
            Issue <span className="required">*</span>
          </label>
          <select
            className="form-input-breakdown form-select-breakdown"
            name="issue"
            value={formData.issue}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Issue --</option>
            <option value="Electrical">Electrical</option>
            <option value="Mechanical">Mechanical</option>
            <option value="Tires">Tires</option>
            <option value="Incident">Incident</option>
          </select>
        </div>
        <div>
          <label className="form-label-breakdown">
            Remarks <span className="required">*</span>
          </label>
          <textarea
            className="form-input-breakdown"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            rows="3"
            required
          />
        </div>
        <div>
          <label className="form-label-breakdown">
            Truck Status <span className="required">*</span>
          </label>
          <select
            className="form-input-breakdown form-select-breakdown"
            name="truck_status"
            value={formData.truck_status}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Status --</option>{" "}
            <option value="Loaded">Loaded</option>
            <option value="Empty">Empty</option>
          </select>
        </div>
        <div>
          <label className="form-label-breakdown">
            JP Status <span className="required">*</span>
          </label>
          <select
            className="form-input-breakdown form-select-breakdown"
            name="jp_status"
            value={formData.jp_status}
            onChange={handleChange}
            required
          >
            <option value="IN_TRANSIT">IN TRANSIT</option>
            <option value="CLOSED">CLOSED</option>
          </select>
        </div>
        <button type="submit" className="submit-button-breakdown1">
          Save
        </button>
      </form>
    </div>
  );
};

export default AddBreakdown;
